<script>
	import { sizeSelect } from "../../store/store";
	export let trigerSelectActiveJob;
	export let trigerSelectUser;
	export let trigerSelectCompleteJob;
	export let trigerSelectIncompleteJob;
	export let trigerSelectDeletedJob;
	export let trigerSelect;

	const defaultOptions = [
		{
			label: "Show 20",
			value: "20",
		},
		{
			label: "Show 40",
			value: "40",
		},
		{
			label: "Show 60",
			value: "60",
		},
	];

	function handleChange(e) {
		sizeSelect.set(e.target.value);
		if (trigerSelectActiveJob) {
			trigerSelectActiveJob(e.target.value);
		} else if (trigerSelectUser) {
			trigerSelectUser(e.target.value);
		} else if (trigerSelectCompleteJob) {
			trigerSelectCompleteJob(e.target.value);
		} else if (trigerSelectIncompleteJob) {
			trigerSelectIncompleteJob(e.target.value);
		} else if (trigerSelectDeletedJob) {
			trigerSelectDeletedJob(e.target.value);
		} else if (trigerSelect) {
			trigerSelect(e.target.value);
		}
	}
</script>

<label for="size" class="visually-hidden">Items per page</label>
<select
	name="size"
	id="size"
	class="form-select getgo select ms-auto"
	bind:value={$sizeSelect}
	on:change={(e) => handleChange(e)}
>
	{#each defaultOptions as option}
		<option value={option.value}>{option.label}</option>
	{/each}
</select>

<style>
	#size {
		width: 120px;
	}
	.form-select getgo select {
		max-width: 120px;
	}
</style>
